import Vue from 'vue'
import Router from 'vue-router'
import {AccountChildRoutes} from '@/modules/account/routes'
import {CheckoutChildRoutes} from '@/modules/checkout/routes'
import {HotelChildRoutes} from '@/modules/hoteldisplay/routes'
// import {BannerChildRoutes} from '@/modules/banner/routes'

import RouterLoader from '@/common/routes-loader'

// import {AdacRoutes} from '@/routes/adac'
// import {LimangoRoutes} from '@/routes/limango'
// import {OoesbRoutes} from '@/routes/ooesb'
// import {DefaultRoutes} from '@/routes/default'

import store from './store'

Vue.use(Router)

//get current shop
// const config = require(process.env.CONFIG_LOCATION)
// let shop = config.whitelabelConfig.short.toLowerCase()

// const getAdditionalRoutes = shop => {
//   switch (shop) {
//     case 'adac':
//       return AdacRoutes
//     case 'limango':
//       return LimangoRoutes
//     case 'ooesb':
//       return OoesbRoutes
//     default:
//       return DefaultRoutes
//   }
// }

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      //prevent scroll to top when inputs (for example searchfields) are clicked and only url query params (from.fullPath != to.fullPath but from.pa) change
      if (to.path !== from.path) {
        return {x: 0, y: 0}
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import(
          /* webpackChunkName: "start" */ /* webpackPreload: true */ './views/Home.vue'
        ),
      meta: {
        breadcrumb: 'Home',
      },
    },
    {
      path: '/urlaub-finden',
      name: 'search',
      component: () =>
        import(
          /* webpackChunkName: "home" */ /* webpackPreload: true */ './views/Search.vue'
        ),
      meta: {
        breadcrumb: 'Home',
      },
    },
    {
      alias: '/checkout/*',
      path: '/checkout',
      component: () =>
        import(/* webpackChunkName: "checkout" */ './views/Checkout.vue'),
      children: CheckoutChildRoutes,
      meta: {
        breadcrumb: {
          label: 'Checkout',
          parent: 'search',
        },
      },
    },
    {
      path: '/account',
      name: 'account',
      component: () =>
        import(/* webpackChunkName: "account" */ './views/Account.vue'),
      children: AccountChildRoutes,
    },
    // {
    //   path: '/banner',
    //   name: 'banner',
    //   component: () =>
    //     import(/* webpackChunkName: "banner" */ './views/BannerAds.vue'),
    //   children: BannerChildRoutes,
    // },
    {
      path: '/password-forgotten',
      name: 'reset-password',
      component: () =>
        import(/* webpackChunkName: "account" */ './views/Account.vue'),
    },
    {
      path: '/search/:keyword',
      name: 'search-keyword',
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Search.vue'),
    },
    {
      path: '/reiseziel/:iso/:country',
      alias: '/reiseziel/:iso',
      name: 'search-by-country',
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Search.vue'),
    },
    {
      path: '/thema/:name/:id',
      alias: '/thema/:id',
      name: 'search-by-theme',
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Search.vue'),
    },
    {
      path: '/view/:id/:key',
      name: 'order-detail',
      component: () =>
        import(/* webpackChunkName: "order" */ './views/Order.vue'),
    },
    {
      path: '/complete/:id/:key',
      name: 'order-complete',
      component: () =>
        import(/* webpackChunkName: "order" */ './views/Order.vue'),
    },
    // {
    //   alias: '/hotel/:id',
    //   path: '/hotel/:name/:id',
    //   name: 'hotel',
    //   children: HotelChildRoutes,
    //   component: () =>
    //     import(/* webpackChunkName: "hotel" */ './views/Hotel.vue'),
    // },
    {
      alias: '/urlaub/*',
      path: '/urlaub',
      name: 'urlaub-main',
      children: HotelChildRoutes,
      component: () =>
        import(/* webpackChunkName: "hotel" */ './views/Hotel.vue'),
    },
    // {
    //   path: '/hotel/:id',
    //   name: 'foo',
    //   component: () =>
    //     import(/* webpackChunkName: "hotel" */ './views/Hotel.vue'),
    //   //import(/* webpackChunkName: "home" */ './views/Home.vue'),
    // },

    {
      path: '/willkommen/:promotion',
      name: 'promotion-redirect',
      component: () =>
        import(
          /* webpackChunkName: "home" */ /* webpackPreload: true */ './views/Search.vue'
        ),
      meta: {
        breadcrumb: 'Home',
      },
    },
    {
      path: '/accessibility',
      name: 'accessibility',
      component: () =>
        import(
          /* webpackChunkName: "accessibility" */ /* webpackPreload: true */ './views/Accessibility.vue'
        ),
      meta: {
        breadcrumb: 'Home',
      },
    },
    //...getAdditionalRoutes(shop),
    ...RouterLoader.getAdditionalRoutes(),
    // {
    //   path: '/blackfriday',
    //   name: 'blackfriday',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-blackfriday" */ /* webpackPreload: true */ './views/Landingpages/BlackFriday.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Black Friday',
    //   },
    // },
    // {
    //   path: '/valentinstag',
    //   name: 'valentine',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-valentine" */ /* webpackPreload: true */ './views/Landingpages/Valentine.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Valentinstag',
    //   },
    // },
    // {
    //   path: '/ostern',
    //   name: 'easter',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-easter" */ /* webpackPreload: true */ './views/Landingpages/Easter.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Ostern',
    //   },
    // },
    // {
    //   path: '/muttertag',
    //   name: 'mothersday',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-mothersday" */ /* webpackPreload: true */ './views/Landingpages/MothersDay.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Muttertag',
    //   },
    // },
    // {
    //   path: '/ssv',
    //   name: 'ssv',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-ssv" */ /* webpackPreload: true */ './views/Landingpages/SummerSale.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'SSV',
    //   },
    // },
    // {
    //   path: '/motorwelt',
    //   name: 'motorwelt',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-motorwelt" */ /* webpackPreload: true */ './views/Landingpages/Motorwelt.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Motorwelt',
    //   },
    // },
    // {
    //   path: '/suedtirol',
    //   name: 'suedtirol',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-suedtirol" */ /* webpackPreload: true */ './views/Landingpages/Suedtirol.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'limango') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Südtirol',
    //   },
    // },
    // {
    //   path: '/deutschland',
    //   name: 'germany',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-germany" */ /* webpackPreload: true */ './views/Landingpages/Germany.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'limango') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Deutschland',
    //   },
    // },
    // {
    //   path: '/schnaeppchen',
    //   name: 'bargain',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-bargain" */ /* webpackPreload: true */ './views/Landingpages/Bargain.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'ooesb') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Deutschland',
    //   },
    // },
    // {
    //   path: '/weihnachten',
    //   name: 'christmas',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "lp-christmas" */ /* webpackPreload: true */ './views/Landingpages/Christmas.vue'
    //     ),
    //   beforeEnter: (to, from, next) => {
    //     const shop = Vue.prototype.$whitelabel.short.toLowerCase()
    //     if (shop === 'adac') {
    //       next()
    //     } else {
    //       next('/')
    //     }
    //   },
    //   meta: {
    //     breadcrumb: 'Weihnachten',
    //   },
    // },
    {
      path: '/to/:id',
      name: 'redirect-to-offer',
      component: () =>
        import(/* webpackChunkName: "static" */ './components/Redirect.vue'),
    },
    {
      path: '/:key',
      name: 'markdown-page',
      component: () =>
        import(
          /* webpackChunkName: "static" */ './views/StaticMarkdownContent.vue'
        ),
      beforeEnter(to, from, next) {
        const page = store.getters.pages.find(
          f => f.slug.toLowerCase() === to.params.key.toLowerCase(),
        )
        if (page || store.getters.pendingContent) {
          next()
        } else {
          next({name: '404'})
        }
      },
    },
    {
      path: '/404',
      alias: '*',
      name: '404',
      component: () =>
        import(
          /* webpackChunkName: "pagenotfound" */ './views/PageNotFound.vue'
        ),
    },
  ],
})
